export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    COMPANY: 'company',
    GUEST: 'guest',
};
